import CardTemplate from '../components/CardTemplate';
import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button } from 'react-bootstrap';
import '../styles/commonStyles.css'
import Api from '../services/request-service';
import { API_URL } from '../services/api_url';
import { useNavigate } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';

const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: 'admin@punt.com',
        password: 'Takeapunt@1995',
      });
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
      };
    
      const token = localStorage.getItem('token');
      if (token) {
          navigate('/');
          return null;
      }

      const LoginService = async (data) => {
        try {
          const response = await Api.post(API_URL.LOGIN, data);
          if (response.status === 200) {
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            navigate('/');
          }
          else {
            throw new Error(response.message);
          }
        } catch (error) {
          console.log(error);
          toast.error(error.message);
        }
      }
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        LoginService(formData);
      };

    const headerContent = (
        <>
          <button className="backButton me-3">
            {/* <ArrowLeft size={25} /> */}
          </button>
          <p className="mb-0 fanstore-text">Login</p>
        </>
      );

      const bodyContent = (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="Email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="formControl"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Control
              type="password"
              placeholder="Password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className="formControl"
            />
          </Form.Group>
          <div>
            <Button
              type="submit"
              className="btnActivate"
              disabled={!formData.email || !formData.password}
            >
              Login
            </Button>
          </div>
        </Form>
      );


    return (
        <div>
            <ToastContainer />
            <CardTemplate headerContent={headerContent} bodyContent={bodyContent} />
        </div>
    )
}

export default Login;